import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppStorage } from 'src/utils/storage';
import { Auth } from '../../types';
const { setItem, getItem } = AppStorage;
const initialState: Auth = getItem('auth', { user: null, userInfos: null });

export const userSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    onSetUser: (state, action: PayloadAction<Auth['user']>) => {
      state.user = action.payload;
      setItem('auth', state);
    },
    onSetUserInfos: (state, action: PayloadAction<Auth['userInfos']>) => {
      state.userInfos = action.payload;
      setItem('auth', state);
    },
    onLogout: (state) => {
      state.user = null;
      state.userInfos = null;
      setItem('auth', state);
    }
  }
});

export const { onLogout, onSetUser, onSetUserInfos } = userSlice.actions;

export default userSlice.reducer;
